import  { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Container,
  TextField,
  InputAdornment,
  Paper
} from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import SearchIcon from '@mui/icons-material/Search';
import PersonIcon from '@mui/icons-material/Person'; // تحتاجه فقط لحالة عدم وجود طلاب
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

// استدعاء مكون كارت الطالب الذي أنشأناه للتو
import StudentCard from './StudentCard'; // تأكد من مسار الملف الصحيح
import { CenterContent, HList, HorizontalMasonryLayout, PageContainer, VList } from '../utils/layouts';
import Loader from '../utils/Loader';

const StudentsList = () => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // الحالات (States)
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [schoolId, setSchoolId] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const userDataStr = localStorage.getItem('user'); 
    if (userDataStr) {
      try {
        const userData = JSON.parse(userDataStr);
        const defaultSchoolId = userData?.school?._id;
        const userClasses = userData?.classes || [];

        if (defaultSchoolId) setSchoolId(defaultSchoolId);
        if (userClasses.length > 0) {
          setClasses(userClasses);
          if(userClasses[0]?._id) {
             setSelectedClass(userClasses[0]._id); 
          }
        }
      } catch (error) {
        console.error("حدث خطأ أثناء قراءة بيانات المستخدم:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedClass && schoolId) {
      fetchStudents(selectedClass, schoolId);
      setSearchQuery(""); 
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClass, schoolId]);

  const fetchStudents = async (classId, sId) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('userToken');
      const response = await axios.get(`${BASE_URL}assessment-criteria/list`, {
        params: { classId: classId, schoolId: sId },
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const studentsData = response.data?.students || [];
      setStudents(studentsData);
    } catch (error) {
      console.error("حدث خطأ أثناء جلب قائمة الطلاب:", error);
      setStudents([]); 
    } finally {
      setLoading(false);
    }
  };

  const handleClassChange = (event) => {
    setSelectedClass(event.target.value);
  };

  const filteredStudents = students.filter((item) => {
    const fullName = item.person?.full_name || "";
    return fullName.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <CenterContent sx={{ minHeight: '100vh'}}>
      <PageContainer >
        <VList>
          {/* الترويسة العلوية */}
        <Paper variant='glass'>
          <HList sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          flexWrap: 'wrap', 
          gap:2
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar sx={{ bgcolor: 'primary.main', width: 50, height: 50 }}>
                <GroupIcon fontSize="medium" />
            </Avatar>
            <Box>
                <Typography variant='pageTitle'>
                  قائمة الطلاب
                </Typography>
                {!loading && students.length > 0 && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0 }}>
                        إجمالي الطلاب: {students.length}
                    </Typography>
                )}
            </Box>
          </Box>

          {/* حاوية أدوات التصفية والبحث */}
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <TextField
            variant='outlined'
              size="small"
              placeholder="ابحث عن طالب..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              disabled={loading || students.length === 0}
              
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />

            <FormControl  size="small">
              <Select
              variant='outlined'
                value={selectedClass}
                onChange={handleClassChange}
                disabled={loading || classes.length === 0}
              >
                {classes.map((cls) => (
                  <MenuItem key={cls._id} value={cls._id}>
                    {cls.ClassName || cls.ClassTitle}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </HList>
        </Paper>

        {/* عرض قائمة الطلاب أو حالة التحميل */}
        {loading ? (
          <Loader/>
        ) : (
          <HorizontalMasonryLayout container spacing={2.5}>
            {filteredStudents.length > 0 ? (
              filteredStudents.map((item) => (
                  // استخدام المكون المنفصل هنا وتمرير الخصائص (Props)
                  <StudentCard 
                  key={item._id}
                    student={item} 
                    onClick={() => navigate(`/student/${item.id}/assessments`)} 
                  />
              ))
            ) : (
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mt: 8, p: 5 }}>
                  <PersonIcon sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
                  <Typography variant="h6" color="text.secondary">
                    {students.length > 0 
                      ? "لا توجد نتائج مطابقة لعملية البحث." 
                      : "لا يوجد طلاب في هذا الصف حالياً."}
                  </Typography>
                </Box>
              </Grid>
            )}
          </HorizontalMasonryLayout>
        )}
        </VList>
      </PageContainer>
    </CenterContent>
  );
};

export default StudentsList;